export default {"src":"/_next/static/media/fitbit_logo.ad6b7dbe.svg","height":45,"width":180};